import React from "react"
import { useAppSelector } from "../../../../../app/hooks"
import { Chip, Stack } from "@mui/material";

function CaseIndicators(){
    const verify = useAppSelector((state)=>state.verification.verification);
    const isPreQuote = verify.verifyAttributes.isPreQuote ?? false;

    const hasIndicators = isPreQuote;
    if(!hasIndicators) return null;

    return <React.Fragment>
        <Stack direction='row' gap={1} sx={{ my: 1, ml: 1 }} flexWrap='wrap' alignItems='center'>
            {isPreQuote && <Chip label="Pre Quote" variant="outlined" sx={{ borderColor: '#9C27B0', color: '#9C27B0', fontWeight: 'bold' }} />}
        </Stack>
    </React.Fragment>
}
export {CaseIndicators}
